import {gql, useMutation} from "@apollo/client";

const UPDATE_ORGANIZATION_REFEREE_STATUS = gql`
    mutation UpdateOrganizationRefereeStatus($organizationId: Int!, $profileId: Int!, $status: String!) {
        updateOrganizationRefereeStatus(organizationId: $organizationId, profileId: $profileId, status: $status) {
            success
        }
    }
`;

export default function UpdateOrganizationRefereeStatusMutation() {
    return useMutation(UPDATE_ORGANIZATION_REFEREE_STATUS);
}
